module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gb-eng-ebbd69accf16823ad6840bbdfef791ba.svg";